import Logo from "@/assets/images/logo.png";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";
import { Analytics as VercelAnalytics } from "@vercel/analytics/react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { MotionLazy } from "./components/animate/motion-lazy";
import { RouteLoadingProgress } from "./components/loading";
import Toast from "./components/toast";
import { AntdAdapter } from "./theme/adapter/antd.adapter";
import { ThemeProvider } from "./theme/theme-provider";
import { ChunkErrorBoundary } from "./components/error-boundary/ChunkErrorBoundary";

function App({ children }: { children: React.ReactNode }) {
	(window as any).timeZone = 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
	return (
		<ChunkErrorBoundary
			onError={(error, errorInfo) => {
				// 记录错误到控制台（生产环境可以发送到监控服务）
				console.error('Application Error:', error, errorInfo);
			}}
		>
			<HelmetProvider>
				<QueryClientProvider client={new QueryClient()}>
					<ThemeProvider adapters={[AntdAdapter]}>
						<VercelAnalytics />
						<Helmet>
							<title>Portal</title>
							<link rel="icon" href={Logo} />
						</Helmet>
						<Toast />
						<RouteLoadingProgress />
						<MotionLazy>{children}</MotionLazy>
					</ThemeProvider>
				</QueryClientProvider>
			</HelmetProvider>
		</ChunkErrorBoundary>
	);
}

export default App;
